import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-income-v2',
  templateUrl: './icon-income-v2.component.html',
  styleUrls: []
})
export class IconIncomeV2Component implements OnInit {
  constructor() {}

  ngOnInit() {}
}
